import { falBadgePercent } from 'shared/@generated/icons/falBadgePercent';
import { falCreditCard } from 'shared/@generated/icons/falCreditCard';
import { falFileContract } from 'shared/@generated/icons/falFileContract';
import { falFingerprint } from 'shared/@generated/icons/falFingerprint';
import { falHandshakeSlash } from 'shared/@generated/icons/falHandshakeSlash';
import { falMessageHeart } from 'shared/@generated/icons/falMessageHeart';
import { falMessageMedical } from 'shared/@generated/icons/falMessageMedical';
import { falShieldKeyhole } from 'shared/@generated/icons/falShieldKeyhole';
import { falVideoCamera } from 'shared/@generated/icons/falVideoCamera';

import { useTranslation } from 'react-i18next';

export function usePetpayFeatures() {
  const { t } = useTranslation('library');

  return [
    {
      icon: falShieldKeyhole,
      title: t('use_petpay_features.payment_protection'),
      description: t('use_petpay_features.payment_protection_description'),
    },
    {
      icon: falFingerprint,
      title: t('use_petpay_features.identity_verification'),
      description: t('use_petpay_features.identity_verification_description'),
    },
    {
      icon: falVideoCamera,
      title: t('use_petpay_features.training'),
      description: t('use_petpay_features.training_description'),
    },
    {
      icon: falFileContract,
      title: t('use_petpay_features.digital_purchase_agreement'),
      description: t('use_petpay_features.digital_purchase_agreement_description'),
    },
    {
      icon: falCreditCard,
      title: t('use_petpay_features.pay_in_installments'),
      description: t('use_petpay_features.pay_in_installments_description'),
    },
    {
      icon: falHandshakeSlash,
      title: t('use_petpay_features.dispute_assistance'),
      description: t('use_petpay_features.dispute_assistance_description'),
    },
    {
      icon: falMessageHeart,
      title: t('use_petpay_features.lifetime_pet_support'),
      description: t('use_petpay_features.lifetime_pet_support_description'),
    },
    {
      icon: falMessageMedical,
      title: t('use_petpay_features.free_vet_consultation'),
      description: t('use_petpay_features.free_vet_consultation_description'),
      comingSoon: true,
    },
    {
      icon: falBadgePercent,
      title: t('use_petpay_features.exclusive_discounts'),
      description: t('use_petpay_features.exclusive_discounts_description'),
      comingSoon: true,
    },
  ];
}
